import React from 'react';

const BlogIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">feed</span>
            </>
      );
};

export default BlogIcon;
